<script>
	import FontSelect from "./components/FontSelect.svelte";
	import SegControl from "./components/SegControl.svelte";
	import ColorPicker from "./components/ColorPicker.svelte";
	import Toggle from "./components/Toggle.svelte";

	import { capitalize } from "./tools.js";
	import { postSettings, headerStyle, bodyStyle, footerStyle, focusBox } from "./stores.js";

	let stobj;
	let hlDisabled;

	let boxStyles = {
		"body": bodyStyle,
		"header": headerStyle,
		"footer": footerStyle
	}

	let stylelist = [
		{
			id: 1,
			val: "bold",
			label: "Bold",
			img: "img/bold.svg"
		},
		{
			id: 2,
			val: "ital",
			label: "Italic",
			img: "img/italic.svg"
		},
		{
			id: 3,
			val: "under",
			label: "Underline",
			img: "img/underline.svg"
		},
		{
			id: 4,
			val: "hilite",
			label: "Highlight",
			img: "img/highlight.svg"
		}
	];

	let alignments = [
		{
			id: 1,
			val: "left",
			label: "Left",
			img: "img/align-left.svg"
		},
		{
			id: 2,
			val: "center",
			label: "Center",
			img: "img/align-center.svg"
		},
		{
			id: 3,
			val: "right",
			label: "Right",
			img: "img/align-right.svg"
		},
		{
			id: 4,
			val: "justify",
			label: "Justify",
			img: "img/align-justified.svg"
		}
	];

	$: {
		stobj = boxStyles[$focusBox];

		hlDisabled = !$stobj.style.includes("hilite");
	}
</script>

<div class="panel--title">
	<h2>Typeface Options</h2>
</div>

<div class="panel--body">
	<h4><span class="emph">{capitalize($focusBox)}</span> Typeface</h4>
	<FontSelect bind:typeface={$stobj.typeface} />

	<h4><span class="emph">{capitalize($focusBox)}</span> Text Style</h4>
	<SegControl items={stylelist} bind:grouplist={$stobj.style} name='style' icon={true} multisel={true} />

	<h4><label for="fontsize"><span class="emph">{capitalize($focusBox)}</span> Text Size</label></h4>
	<input type="range" name="fontsize" bind:value={$stobj.fontsize} id="fontsize" min="5" max="40">

	<h4><span class="emph">{capitalize($focusBox)}</span> Text Alignment</h4>
	<SegControl items={alignments} bind:group={$stobj.align} name='align' icon={true} />

	<h4><span class="emph">{capitalize($focusBox)}</span> Text</h4>
	<div id="txt-colors">
		<div id="txtcol" class="cell">
			<label for="txtcol">Color</label>
			<ColorPicker bind:color={$stobj.txtcolor} />
		</div>
		<div id="txtbg" class="cell {hlDisabled ? 'disabled' : ''}">
			<label for="txtbg">Highlight</label>
			<ColorPicker bind:color={$stobj.hlcolor} bind:disabled={hlDisabled}/>
		</div>
	</div>

	<!--
		<h4><span class="emph">{capitalize($focusBox)}</span> Text Color</h4>
		<ColorPicker bind:color={$stobj.txtcolor} />

		<h4><span class="emph">{capitalize($focusBox)}</span> Text Highlight</h4>
		<ColorPicker bind:color={$stobj.hlcolor} bind:disabled={hlDisabled}/>
	-->

</div>

<style lang="scss">
	.cell.disabled label {
		opacity: 0.5;
	}
</style>
